import { useSelector } from 'react-redux';

import { slices } from '~/redux/slices';
import { User } from '~/types/User';

export const useCurrentUser = (): User => {
  return useSelector(slices.currentUser.selectors.selectCurrentUser);
};
